<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      type="bar"
      :raw-data="players"
      :chart-value-keys="chartValueKeys"
      x-value="last_name"
      :y-value-prefix="aggregation && !removable ? 'latest_stats.' : 'player_stats.'"
      :yaxis="[ { title: { text: $t('chart_legends.distance') }} ]"
      :stacked="true"
      :xaxis="{
        labels: {
          rotate: -45
        },
        categories: players.map(p => p.first_name[0] + '. ' + p.last_name ),
        tickPlacement: 'between'
      }"
      :colors="[ '#008FFB', '#F4A641', '#F9E03B', '#86CC8E', '#DD644C']"
      :fill="{ opacity: [1, 1, 1, 1, 1]}"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <div class="subtitle-2 grey--text text--grey-100">
            {{ $t('card_title.distance_zone_breakdown') }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
          </div>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.distance_zone_breakdown') }}{{ aggregation ? ": " + $t(`variables.${aggregation}.long`) : '' }}
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <v-data-table
        :headers="tableHeaders"
        :items="players"
        hide-default-footer
        disable-pagination
        :items-per-page="-1"
        fixed-header
        dense
        :height="350"
      >
        <template v-slot:item.last_name="{ item }">
          {{ item.last_name }}, {{ item.first_name }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'

export default {
  name: 'SpeedZoneChart',
  components: { LineChart, VisualListToggle },
  props: {
    players: {
      type: Array,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    },
    aggregation: {
      type: String,
      default: null
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    chartValueKeys() {
      const addAggregation = (key) => this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
      return [
        { key: addAggregation('CACTCSVB1TD'), type: 'bar', label: this.$t('variables.CACTCSVB1TD.long') },
        { key: addAggregation('CACTCSVB2TD'), type: 'bar', label: this.$t('variables.CACTCSVB2TD.long') },
        { key: addAggregation('CACTCSVB3TD'), type: 'bar', label: this.$t('variables.CACTCSVB3TD.long') },
        { key: addAggregation('CALETLDLHSR'), type: 'bar', label: this.$t('variables.CALETLDLHSR.long') },
        { key: addAggregation('CALETLDLSP'), type: 'bar', label: this.$t('variables.CALETLDLSP.long') }
      ]
    },
    tableHeaders() {
      const addAggregation = (key) => this.aggregation && !this.removable ? `${key}_${this.aggregation}` : key
      const valuePrefix = this.aggregation && !this.removable ? 'latest_stats.' : 'player_stats.'

      return [
        {
          text: this.$t('table_headers.name'),
          value: 'last_name',
          sortable: true,
          width: '20%'
        },
        {
          text: this.$t('gps_variables.speed_0_7'),
          value: valuePrefix + addAggregation('CACTCSVB1TD'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('gps_variables.speed_7_14.4'),
          value: valuePrefix + addAggregation('CACTCSVB2TD'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('gps_variables.speed_14.4_19.8'),
          value: valuePrefix + addAggregation('CACTCSVB3TD'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('gps_variables.hsr'),
          value: valuePrefix + addAggregation('CALETLDLHSR'),
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('gps_variables.sprint'),
          value: valuePrefix + addAggregation('CALETLDLSP'),
          sortable: true,
          align: 'center'
        }
      ]
    }
  }
}
</script>
